var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeMiterlimit: 10,
  strokeWidth: 1.25,
  d: "M4.754 19.28s.054.093.08.133c.028.04.055.094.082.147 5.01 8.64 13.668 13.72 15.275 11.067l2.026-3.8c.162-.32.135-.72-.068-1.094l-.027-.026c-.284-.547-.54-.56-2.026-1.534-.77-.573-1.58-1.186-2.134-1.653-.526-.453-1.27-.48-1.701-.067l-.838.814c-.284.28-.675.426-1.08.426-1.202-.013-3.498-3.226-4.781-5.2a24 24 0 0 1-.81-1.32c-.163-.28-.433-.773-.743-1.36-1.08-2.093-2.715-5.666-2.12-6.693.188-.347.526-.6.918-.707L7.94 8.12c.58-.16.932-.813.797-1.48-.135-.693-.257-1.707-.378-2.653-.095-1.747.013-1.974-.31-2.494v-.026c-.217-.36-.555-.587-.92-.614l-4.348-.2C-.338.693-.257 10.64 4.754 19.28Z"
})));
export default SvgCall;